import React from "react";

function RegistryStatCards({
  cards = [],
  stats = {},
  minColumnWidth = 200,
  loading = false,
  className = "mb-4",
  pulseWhen = {},
}) {
  return (
    <div
      className={`grid gap-2.5 ${className}`}
      style={{ gridTemplateColumns: `repeat(auto-fit, minmax(${minColumnWidth}px, 1fr))` }}
    >
      {cards.map((item) => {
        const Icon = item.Icon;
        const shouldPulse = Boolean(pulseWhen[item.key] && (stats[item.key] ?? 0) > 0);
        return (
          <div
            key={item.key}
            className={`relative overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm ${
              shouldPulse ? "registry-stat-card--expiring-pulse" : ""
            }`}
            style={{ padding: "14px 16px" }}
          >
            <div
              className="absolute inset-x-0 top-0 h-[3px]"
              style={{ backgroundColor: item.color }}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              {loading ? (
                <div
                  className="skeleton shrink-0 rounded-[10px]"
                  style={{ width: "42px", height: "42px" }}
                  aria-hidden="true"
                />
              ) : (
                <div
                  className={`${
                    item.key === "expiring" ? "registry-stat-expiring-icon" : ""
                  }`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "42px",
                    height: "42px",
                    borderRadius: "10px",
                    backgroundColor: item.iconBg,
                    flexShrink: 0,
                  }}
                >
                  <Icon size={18} style={{ color: item.color }} />
                </div>
              )}
              <div style={{ minWidth: 0, flex: 1 }}>
                {loading ? (
                  <>
                    <div className="skeleton h-6 w-10 rounded" aria-hidden="true" />
                    <div className="skeleton mt-1.5 h-3 w-24 rounded" aria-hidden="true" />
                  </>
                ) : (
                  <>
                    <p className="text-xl font-bold tabular-nums leading-none text-[#35314d]">
                      {stats[item.key] ?? 0}
                    </p>
                    <p className="mt-1.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      {item.label}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default RegistryStatCards;
